import React from "react";
import { useAuth } from "../context/AuthContext";
import { Lock, Unlock, ExternalLink } from "lucide-react";

const ContentPage = () => {
	const { hasAccess } = useAuth();

	const projects = [
		{
			id: 1,
			title: "E-commerce Platform",
			description: "Full-stack shopping experience",
			restricted: false,
			demoUrl: "#",
		},
		{
			id: 2,
			title: "Mobile Banking App",
			description: "Secure financial management",
			restricted: true,
			demoUrl: "#",
		},
		{
			id: 3,
			title: "Social Media Dashboard",
			description: "Analytics and insights",
			restricted: false,
			demoUrl: "#",
		},
		{
			id: 4,
			title: "Healthcare Portal",
			description: "Patient management system",
			restricted: true,
			demoUrl: "#",
		},
		{
			id: 5,
			title: "Real Estate Platform",
			description: "Property listings and tours",
			restricted: true,
			demoUrl: "#",
		},
		{
			id: 6,
			title: "Education LMS",
			description: "Learning management system",
			restricted: false,
			demoUrl: "#",
		},
	];

	const canAccess = (project) => {
		return !project.restricted || hasAccess;
	};

	return (
		<div className="space-y-6">
			<div>
				<h2 className="text-3xl font-bold text-white mb-2">My Content</h2>
				<p className="text-gray-400">
					Browse and access your assigned projects and demos.
				</p>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{projects.map((project) => {
					const accessible = canAccess(project);
					return (
						<div
							key={project.id}
							className={`bg-gray-800 border border-gray-700 rounded-lg p-6 transition-all ${
								accessible ? "hover:border-orange-500" : "opacity-60"
							}`}
						>
							<div className="flex items-start justify-between mb-4">
								<h3 className="text-lg font-semibold text-white">
									{project.title}
								</h3>
								{accessible ? (
									<Unlock className="w-5 h-5 text-green-500" />
								) : (
									<Lock className="w-5 h-5 text-red-500" />
								)}
							</div>
							<p className="text-gray-400 text-sm mb-4">
								{project.description}
							</p>
							{accessible ? (
								<button className="w-full bg-gradient-to-r from-orange-700 to-orange-500 text-white py-2 rounded-lg hover:from-orange-800 hover:to-orange-600 transition-all flex items-center justify-center space-x-2">
									<span>View Demo</span>
									<ExternalLink className="w-4 h-4" />
								</button>
							) : (
								<div className="w-full bg-gray-700 text-gray-400 py-2 rounded-lg text-center">
									Access Restricted
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ContentPage;
